import { Button, ButtonProps, styled, Typography } from "@mui/material";
import { ReactElement } from "react";
// eslint-disable-next-line no-restricted-imports
import { Link, LinkProps } from "react-router-dom";

import { palette } from "~frontend/theme";

export const BUTTON_WIDTH = "100px";

const OutlinedFocusLink = styled(Link)({
  border: "1px solid transparent",
  "&:focus,:focus-visible": {
    outline: `2px solid ${palette.darkBlue}`,
    outlineOffset: "0px",
    border: "1px solid white",
  },
});

export function ActionButton(
  props: Omit<ButtonProps, "onClick"> & LinkProps
): ReactElement {
  const { sx, children, to, onClick, ...otherProps } = props;

  return (
    <OutlinedFocusLink to={to} onClick={onClick} className="actionButton">
      <Button
        variant="contained"
        sx={{ width: BUTTON_WIDTH, height: "27px", ...sx }}
        component="div"
        role="none"
        tabIndex={-1}
        {...otherProps}
      >
        <Typography variant="h4Caps">{children}</Typography>
      </Button>
    </OutlinedFocusLink>
  );
}
